const EXTENSION_BY_MIME: Record<string, string> = {
  'video/mp4': 'mp4',
  'video/mpeg': 'mpeg',
  'video/webm': 'webm',
  'video/quicktime': 'mov',
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/webp': 'webp',
  'image/svg+xml': 'svg',
  'image/gif': 'gif',
  'audio/mpeg': 'mp3',
  'audio/ogg': 'ogg',
  'audio/wav': 'wav',
  'audio/webm': 'webm',
  'audio/mp4': 'm4a',
  'application/pdf': 'pdf',
}

const HAS_FILE_EXTENSION = /\.[a-z0-9]{2,5}$/i

export const extensionFromMimeType = (mimeType: string): string | undefined => {
  return (
    EXTENSION_BY_MIME[mimeType] ??
    mimeType.split('/')[1]?.replace(/^x-/, '').replace('jpeg', 'jpg').replace('quicktime', 'mov')
  )
}

/**
 * Ensure upload filenames include an extension derived from the MIME type.
 * Blaze S3 keys are built from the filename, and uploads often arrive without
 * one (e.g. camera roll or pasted blobs). Many clients infer media format from
 * the URL path, not Content-Type alone — an extensionless key can fail to load
 * or pick the wrong decoder. Appending the extension before upload keeps the
 * stored URL recognizable as the correct file type.
 */
export const ensureUploadFilename = (filename: string, mimeType: string): string => {
  const trimmed = filename.trim() || 'upload'
  if (HAS_FILE_EXTENSION.test(trimmed)) {
    return trimmed
  }

  const extension = extensionFromMimeType(mimeType)

  return extension ? `${trimmed}.${extension}` : trimmed
}

export const ensureUploadFile = (file: File): File => {
  const filename = ensureUploadFilename(file.name, file.type)
  if (filename === file.name) {
    return file
  }

  return new File([file], filename, { type: file.type, lastModified: file.lastModified })
}
